// extracted by mini-css-extract-plugin
module.exports = {"upload-wrapper":"upload-wrapper___2Cygd","icon-upload-icon":"icon-upload-icon___2b_2l"};